import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ABOSFunction } from '../../../model/ABOSFunction';
import { ABOSLink } from '../../../model/ABOSLink';
import { ApplicationService } from '../../../service/application.service';
import { Router } from '@angular/router';
import { CurrentUser } from '../../../../model/CurrentUser';
import { DarkModeService } from '../../../service/dark-mode.service';

@Component({
  selector: 'ch-sidenav',
  templateUrl: './sidenav.component.html'
})
export class SidenavComponent implements OnInit {

  coreFunctions: Array<ABOSFunction>;
  otherFunctions: Array<ABOSFunction>;
  links: Array<ABOSLink>;

  route: string;
  currentUser: CurrentUser;

  constructor(public readonly router: Router,
              public readonly darkModeService: DarkModeService,
              private readonly location: Location) {
  }

  ngOnInit(): void {
    this.router.events.subscribe(() => {
      this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
      if (this.currentUser) {
        this.coreFunctions = ApplicationService.coreFunctions.filter(f => this.currentUser.permissions.includes(f.permission));
        this.otherFunctions = ApplicationService.otherFunctions.filter(f => this.currentUser.permissions.includes(f.permission));
        this.links = ApplicationService.links.filter(l => this.currentUser.permissions.includes(l.permission));
      }
      if (this.location.path() !== '') {
        this.route = this.location.path();
      } else {
        this.route = 'Home';
      }
    });
  }


}
